// @flow

import React from 'react';

import { urlWithNext } from '@zapier/url-utils';

type LoginDifferentProps = {
  next: string,
};

const LoginDifferent = ({ next }: LoginDifferentProps) => {
  next = urlWithNext('/app/login', next);
  const logoutHref = urlWithNext('/logout/', next);
  return (
    <div>
      <p>{<a href={logoutHref}>Log in as a different user</a>}</p>
    </div>
  );
};

export default LoginDifferent;
